module.exports = __webpack_public_path__ + "static/media/banner-outlet-australia.1e18be06.png";